// WO-71 — Mid2Bid Referral Programme Terms, version 1.0 (BILAL, 23 October 2026).
// Generated word for word from the lawyer's document. Do NOT edit by hand: a change
// of wording is a new version of the Terms (clause 11) and comes from BILAL.
export const TERMS_VERSION = '1.0';
export const TERMS_V1 = [
 [
  "FirstParagraph",
  "Version 1.0 — last updated 23 October 2026"
 ],
 [
  "BodyText",
  "English is the governing text. Any translation is for convenience only."
 ],
 [
  "BodyText",
  "1. Who runs the Programme, and what these Terms include"
 ],
 [
  "BodyText",
  "1.1 The Mid2Bid Referral Programme (“the Programme”) is run by PASTORIA PROJECT, S.L., a Spanish company with tax number B57664179 and registered office at Camino Son Rapiña 8, 1ºA, 07013 Palma de Mallorca, Spain (“Mid2Bid”, “we”, “us”)."
 ],
 [
  "BodyText",
  "1.2 These Terms form part of the Mid2Bid Terms of Service. The page “How to share your code, and tax on your commissions” forms part of these Terms. If these Terms conflict with the Terms of Service or with that page, these Terms prevail for the Programme."
 ],
 [
  "BodyText",
  "1.3 You accept these Terms by ticking the acceptance box in the app. We record the version you accepted and the date."
 ],
 [
  "BodyText",
  "2. Who can take part"
 ],
 [
  "BodyText",
  "2.1 Any registered Mid2Bid user aged 18 or over, on any plan, may take part (“you”, a “Referrer”)."
 ],
 [
  "BodyText",
  "2.2 By taking part you confirm that the law of the country where you live, and any employment or other contract you have, allow you to receive commissions under the Programme. If they do not, you must not request payment; you may still share your code."
 ],
 [
  "BodyText",
  "3. What the Programme is, and what it is not"
 ],
 [
  "BodyText",
  "You may share your personal referral code or link. You are under no obligation to refer anyone, to publish anything or to reach any number. There is no territory and no exclusivity. You act on your own account. You have no authority to negotiate, accept, sign or promise anything on behalf of Mid2Bid. Taking part does not make you our employee, agent, representative or partner. It gives you no right to shares, employment, a role or any payment other than those set out in these Terms."
 ],
 [
  "BodyText",
  "4. What the Referred Customer gets"
 ],
 [
  "BodyText",
  "A person who registers with your code or link and is not already a Mid2Bid customer (a “Referred Customer”) gets 15% off every payment for plans, reports and white-label licences made during the 12 months that start on the date of their first payment. At checkout we tell the Referred Customer that the owner of the code receives a commission from us."
 ],
 [
  "BodyText",
  "5. What you earn"
 ],
 [
  "BodyText",
  "5.1 You earn a commission of 15% of every payment made by a Referred Customer during the 12 months that start on the date of that customer’s first payment, or 24 months if the Referred Customer buys an Enterprise plan (the “Commission Window”)."
 ],
 [
  "BodyText",
  "5.2 Commission is calculated on the amount we actually receive, excluding VAT and any similar tax, and after any discount."
 ],
 [
  "BodyText",
  "5.3 You earn nothing on: free accounts; payments made by you or for your benefit (self-referral), including through another person or another account; payments refunded or charged back; or payments made through a code used in breach of these Terms."
 ],
 [
  "BodyText",
  "5.4 Colleagues count. A person from your own organisation who pays counts as a Referred Customer. However, where the payment is made by an organisation for which you work or act, and you take part in or influence its decision to buy, you earn commission only if that organisation knows that you receive it. Where the code belongs to someone at the same organisation, we ask the buyer to confirm that the organisation knows. If the buyer does not confirm, no commission is created on that purchase."
 ],
 [
  "BodyText",
  "6. Pending and Available commissions"
 ],
 [
  "BodyText",
  "6.1 Each commission is “Pending” for 30 days after the payment it relates to. If the payment is refunded in full during that time, the commission is cancelled. If it is refunded in part, the commission is reduced in proportion. If the payment is disputed with the card issuer, the commission is frozen until the dispute is decided."
 ],
 [
  "BodyText",
  "6.2 After 30 days the commission becomes “Available”."
 ],
 [
  "BodyText",
  "6.3 If a payment is refunded, charged back or reversed after the commission has become Available or has been paid, we may deduct the corresponding commission from your later commissions."
 ],
 [
  "BodyText",
  "7. Requesting payment"
 ],
 [
  "BodyText",
  "7.1 When your Available balance reaches USD 50, you may request payment from the Withdrawals tab. You must give the information listed in clause 8.6. The bank account must be in your own name. We do not pay into third-party accounts."
 ],
 [
  "BodyText",
  "7.2 We normally pay within 14 days of a complete request, and in any case within 30 days. A request is complete when we have all the information and documents we need, including any document under clause 8, and the result of the checks in clause 7.4."
 ],
 [
  "BodyText",
  "7.3 We pay by bank transfer, in US dollars. We pay our own bank’s charges. Any charges of intermediary or receiving banks, and any currency conversion, are for you."
 ],
 [
  "BodyText",
  "7.4 Before paying, we check that the account holder’s name matches yours and that the payment is not prohibited by sanctions laws. If either check raises a question, we may ask you for an identity document, and we will not pay until the question is resolved. We do not make payments to persons, banks or countries where sanctions laws prohibit or restrict them."
 ],
 [
  "BodyText",
  "7.5 You may delete your saved bank details at any time."
 ],
 [
  "BodyText",
  "7.6 Balances do not expire. A balance below USD 50 stays in your account until it reaches USD 50, or until clause 12.3 applies."
 ],
 [
  "BodyText",
  "8. Tax"
 ],
 [
  "BodyText",
  "8.1 You are responsible for declaring and paying any tax on your commissions in your own country."
 ],
 [
  "BodyText",
  "8.2 Where Spanish law requires it, we deduct tax from a payment and pay it to the Spanish tax authority on your behalf. We show you any deduction, and the net amount, before you confirm your request."
 ],
 [
  "BodyText",
  "8.3 You “refer customers regularly” if you are an Ambassador, or if more than 50 different Referred Customers made their first payment through your code in a single calendar month. If you refer customers regularly and live outside Spain, Spanish law may require us to deduct tax at the rate in force (currently 24%, or 19% for residents of the European Union, Iceland, Norway and Liechtenstein). We will not deduct it if you give us a certificate of tax residence issued by the tax authority of a country that has a tax treaty with Spain, stating that you are resident there for the purposes of that treaty. A certificate is valid for one year from its date."
 ],
 [
  "BodyText",
  "8.4 If you live in Spain and refer customers regularly, we will contact you before your first payment to deal with Spanish income tax and VAT."
 ],
 [
  "BodyText",
  "8.5 Payment documents. For every payment we issue a statement of the commissions paid. Where you supply the service as a business, or refer customers regularly, you agree that we issue the invoice on your behalf (self-billing). Each statement or invoice is treated as accepted by you unless you tell us otherwise within 15 days of receiving it. You do not need to send us an invoice."
 ],
 [
  "BodyText",
  "8.6 Information we need before paying. On your first withdrawal request you must give us: whether you act as a private person or as a company (and, for a company, its legal name, registration number and VAT number); your full legal name; your country of tax residence; your full postal address; your tax identification number or, if your country has none for individuals, your national identity or residence-card number; and your bank details. If clause 8.3 applies to you, you may also give us a tax-residence certificate."
 ],
 [
  "BodyText",
  "8.7 You must tell us within 30 days, and before your next withdrawal request, if your country of tax residence changes or if any information you gave us under clause 8.6 becomes incorrect. We rely on the information you give us. If incorrect information means that we have to pay tax, interest or penalties that we would not otherwise have paid, we may deduct those amounts from your later commissions or ask you to repay them."
 ],
 [
  "BodyText",
  "9. Rules on promotion"
 ],
 [
  "BodyText",
  "9.1 You may describe Mid2Bid in your own words and give your honest opinion of it."
 ],
 [
  "BodyText",
  "9.2 You must not: state prices, except by linking to our price page; say that Mid2Bid is “the only” platform of its kind, or use “all” or “every” to describe its coverage; give figures for the number of portals, tenders, projects or companies; compare Mid2Bid with a named competitor, or say anything about a competitor’s quality; promise results; present yourself as Mid2Bid staff; post or arrange fake reviews; send unsolicited bulk messages; or buy online advertising using the Mid2Bid name."
 ],
 [
  "BodyText",
  "9.3 Share your code privately, not publicly. You may give your code or link to people personally — by direct message, e-mail, messaging app or in conversation — addressing each person individually. You must not publish your code or link, or an invitation to ask you for it or for a discount (for example “comment below and I will send you my code”), in any public post, comment, article, profile, headline, story, video or group. Public offers are made only by Mid2Bid itself, on its own pages."
 ],
 [
  "BodyText",
  "9.4 You may talk about Mid2Bid publicly and share Mid2Bid’s posts, giving your honest opinion and following clause 9.2, provided the post contains no code, no link with your code, no discount and no invitation of the kind described in clause 9.3. You are not rewarded for public posts. If someone you contact privately asks, tell them that you receive a commission."
 ],
 [
  "BodyText",
  "9.5 Do not send the same message to large numbers of people, or to people who have asked you not to contact them. Each message must be personal to the person who receives it."
 ],
 [
  "BodyText",
  "10. Fraud and breach"
 ],
 [
  "BodyText",
  "10.1 We may refuse, cancel or withhold commissions, deduct them from later commissions, or ask you to repay commissions already paid, where we have evidence of: fake, duplicate or self-controlled accounts; self-referral; promotion in breach of clause 9; a breach of clause 5.4; or any other abuse of the Programme."
 ],
 [
  "BodyText",
  "10.2 We will tell you the reason. We may also suspend or end your participation in these cases."
 ],
 [
  "BodyText",
  "11. Changes to these Terms"
 ],
 [
  "BodyText",
  "11.1 We may change these Terms for legal or tax reasons, to prevent fraud, or for commercial reasons. We will give you at least 30 days’ notice by e-mail and in the app, and show you the new version."
 ],
 [
  "BodyText",
  "11.2 If you do not agree, you may stop taking part before the change takes effect. You must accept the new version before your next withdrawal request."
 ],
 [
  "BodyText",
  "11.3 A change never applies to a Referred Customer who made a first payment before the change takes effect. That customer’s Commission Window stays under the version of these Terms in force on the date of that first payment."
 ],
 [
  "BodyText",
  "12. Ending your participation, or the Programme"
 ],
 [
  "BodyText",
  "12.1 You may stop taking part at any time."
 ],
 [
  "BodyText",
  "12.2 We may end your participation, or end the Programme, with 30 days’ notice, or immediately under clause 10. Unless we end your participation under clause 10, you keep earning commission on Referred Customers whose first payment was made before the end date, until their Commission Windows end."
 ],
 [
  "BodyText",
  "12.3 When your participation ends, your account is closed or the Programme ends, we will pay any Available balance on request, whatever its amount. The USD 50 minimum does not apply."
 ],
 [
  "BodyText",
  "13. Your data"
 ],
 [
  "BodyText",
  "We process your information for the Programme as described in our Privacy Policy, under the heading “Referral Programme”."
 ],
 [
  "BodyText",
  "14. Law and disputes"
 ],
 [
  "BodyText",
  "These Terms are governed by Spanish law. The courts of Palma de Mallorca have jurisdiction, without depriving you of any protection or forum that the law of the country where you live gives you as a consumer."
 ],
 [
  "Heading2",
  "Section A — Ambassadors"
 ],
 [
  "FirstParagraph",
  "A1. What an Ambassador is. An Ambassador is a Referrer we have invited personally. Clauses 1 to 14 apply to you, with the additions below. If this section conflicts with clauses 1 to 14, this section prevails. Joining as an Ambassador is optional."
 ],
 [
  "BodyText",
  "A2. Free Premium. You receive the Premium plan free for 12 months from the date you accept this section (an “Ambassador Year”), with no payment card. This is a gift. It does not depend on you publishing anything or doing anything for us."
 ],
 [
  "BodyText",
  "A3. Renewal. Your free Premium renews automatically for a further Ambassador Year each time you bring in more than 100 new paying users during an Ambassador Year. A “new paying user” is each user — and each paid seat of a company plan — whose first payment is made with your code during that Ambassador Year and is not refunded or charged back within 30 days."
 ],
 [
  "BodyText",
  "A4. End of the free period. If the condition in clause A3 is not met, your account returns automatically to the plan it had before at the end of the Ambassador Year. Nothing is charged. We will remind you by e-mail and in the app 14, 7 and 1 days before. If you want to keep Premium, you can choose a paid plan; we will never move you to a paid plan without your request."
 ],
 [
  "BodyText",
  "A5. Premium only. You may choose to take the free Premium without taking part in the commission side of the Programme. You may change that choice at any time."
 ],
 [
  "BodyText",
  "A6. Terms in our invitation. If you received a written invitation from us, the commission rate, the Commission Windows, the discount for your Referred Customers and the renewal rule in clause A3 will not be changed for you for as long as the Programme runs, whatever changes are made for other users under clause 11."
 ],
 [
  "BodyText",
  "A7. Recruitment. If you are, or become, a candidate for a job with us or with any company of our group, taking part in the Programme, or declining to, has no effect on any hiring decision. If you become our employee or the employee of a company of our group: from your start date you earn no further commission under the Programme; commissions already Pending or Available on that date are paid in the normal way; any sales incentive will be set out in your employment contract; and your free Premium ends, because you will use a company seat."
 ],
 [
  "BodyText",
  "A8. Your confirmation. By accepting, you confirm that you will follow clause 9, in particular that you will share your code only privately (clause 9.3). The title “Ambassador” describes your place in the Programme; please do not use it publicly as a job title or in your profile headline."
 ],
 [
  "Heading2",
  "Section F — First Fifty"
 ],
 [
  "FirstParagraph",
  "F1. What First Fifty is. First Fifty is a trial offered personally by us to selected customers. Joining is optional."
 ],
 [
  "BodyText",
  "F2. Free Premium for 90 days. You receive the Premium plan free for 90 days from the date you accept this section, with no payment card. This is a gift; it does not depend on you doing anything for us."
 ],
 [
  "BodyText",
  "F3. End of the trial. At the end of the 90 days your account returns automatically to the plan it had before. Nothing is charged. We will remind you by e-mail and in the app 14, 7 and 1 days before. If you want to keep Premium, you can choose a paid plan; we will never move you to a paid plan without your request."
 ],
 [
  "BodyText",
  "F4. Referrals. As a First Fifty user you may take part in the Programme like any other user, under clauses 1 to 14."
 ]
];
